import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Icon } from '../../../core/models/icon.model';
import { IconComponent } from '../icon/icon.component';

type ButtonSize = 'small' | 'medium' | 'large';

type ButtonVariant = 'primary' | 'outline' | 'dashed';

@Component({
  selector: 'umkt-action-button',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './action-button.component.html',
  styleUrl: './action-button.component.scss'
})
export class ActionButtonComponent {
  @Input() label!: string;
  @Input() icon?: Icon;
  @Input() size: ButtonSize = 'large';
  
  @Input() variant: ButtonVariant = 'dashed';

  @Input() disabled: boolean = false;

  @Output() clicked = new EventEmitter<void>();

  handleClick() {
    if (this.disabled) {
      return;
    }
    this.clicked.emit();
  }
}